import { QueryFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { IncomeType } from './types';

const getIncomeType: QueryFunction<
  IncomeType,
  ['/income-types', string]
> = async ({ queryKey }) => {
  const id = queryKey[1];
  if (isMockServices()) {
    return await mock({
      id,
      type: 'W-2 Employment Income',
      documents: [],
      formJson: {},
      inUse: true,
    } as IncomeType);
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean; data: IncomeType }>(
    `/income-types/${id}`,
    { method: 'GET' },
  );

  if (response.data) return response.data.data;
  throw new Error('Failed to fetch income type');
};

export default getIncomeType;
